// extracted by mini-css-extract-plugin
export default {"empty":"index_empty__MLIen","picture":"index_picture__WwhZE","label":"index_label__m1m7v"};